import React from 'react';
import { connect } from 'react-redux';
import { IModalsReducer } from '../../store/modules/ModalsReducer';
import { IReducer } from './../../store/Reducer';

export interface IModalsManager {
  modals: IModalsReducer
}

class ModalsManager extends React.Component<IModalsManager, any> {
  render() {
    /* eslint-disable-next-line */
    return this.props.modals.modals.map((modal, index) => {
        if (modal.opened) {
          const $component: any = modal.component;
          const modalProps = {
            ...modal.componentProps,
            modalKey: modal.key,
            key: index,
            opened: modal.opened
          }
          /* eslint-disable-next-line */
          return <$component  { ...modalProps } />;
        }
      })
  }
}

const mapStateToProps = (state: IReducer) => ({
  modals: state.modals
});

export default connect(mapStateToProps)(ModalsManager);